import React from "react";
import SlideShow from '../components/slideshow/ProjectSevenSlide' 

function ProjectSeven(){
  const backgroundImage = 'url(../assets/images/wilmington-slide.jpg)';

  const style = {
      backgroundImage,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
  };

  return (
 <div>
 
    <div className="project-slider">
        <div className="third-wrapper">
            
            <div className="frame">
            <div id="projectSlideImg" style={style}>
                <div className="img-fade"></div>
                </div>
                <div className="wrapper">
                    <div className="project-slide-des">
                        <h1>Sheppard & Bathurst</h1>
                        <p>25 - 41 Wilmington Ave, Toronto.</p>
                    </div>
                </div>
            </div>     
        </div> 
    </div>
 
  
        <section className="project">
            <div className="divider-project">
                <div className="project-des">
                  <h2>Project Details</h2>
                  <p><strong>Lot:</strong> 150' x 120' (3 lots in total)</p>
                  <p><strong>Total SQF:</strong> 15,100 Sqf</p>
                  <p><strong>Location:</strong> 25 - 41 Wilmington Ave, Toronto.</p>
                  <p><strong>Status:</strong> Completed (Mar 2018 - Sep 2020)</p>
                  <p><strong>Architect:</strong> N/A</p>
                  <p><strong>Interior:</strong> JCG Homes & Kamran Pak</p>
                </div>

            </div>
        </section>
        
 
        <div className="project-leadership-img">
            <div className="img-construction">
                <img src="../assets/images/home-birds.png" alt="home construction"/>
            </div>   
        </div>
    <div className="wrapper">
      <section className="project-des-section">

        <h3>Project Description</h3>
        <p>Description</p>

      </section>
    </div>

 
    <div className="wrapper">
        <section className="project-section">

                <SlideShow/>
          
        </section>
    </div>


    </div>
  );
}

export default ProjectSeven;